import { Dropdown, Button, Card, ProgressBar } from "react-bootstrap";

import "../../assets/scss/reports/cashbook.scss";
import "../../assets/scss/dashboard.scss";
import { useEffect, useRef, useState } from "react";
import CachedIcon from "mdi-react/CachedIcon";
import useDebounce, {
  useCurrencies,
  useQueryParams,
  useScrollTop,
} from "../../utils/hooks";
import { appSettings, services } from "../../config";
import { reportActions } from "../../utils/reactQueryActions";
import { useQuery, useMutation } from "react-query";
import currency from "currency.js";
import queryString from "query-string";
import { useAuth } from "../../hooks/useAuth";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import ModalLoader from "../utils/ModalLoader";
import ChevronDownIcon from "mdi-react/ChevronDownIcon";
import InvoiceAnalysisChart from "./InvoiceAnalysisChart";
import InvoiceAnalysisPieChart from "./InvoiceAnalysisPieChart";
import CustomerProfileWrapper from "./CustomerProfileWrapper";
import { fetchActionsUtil } from "../../utils/helpers";
import { ReoccurringInvoiceIcon, StandardInvoiceIcon } from "../Icons";
import "../../assets/scss/dashboard.scss";

export default function CustomerDashboard() {
  useScrollTop();
  const navigate = useNavigate();
  const { backendUrl, token, user: authUser, customer } = useAuth();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("customerId");

  const initialFilterParams = {
    customerName: "",
    customerId: "",
    Staff_ID: customer?.Staff_ID,
    // startDate: "",
    // endDate: "",
    enableDateRange: false,
    DocType: "Invoice",
  };

  const { prevailingCurrencySymbol } = useCurrencies();

  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });

  const [filterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });

  const { data, refetch } = useQuery(
    ["GET_CUSTOMER_TARGETS_DASHBOARD", queryParams],
    () =>
      fetchActionsUtil(
        `${backendUrl}/api/company/target/${filterParams.customerId}`
      ),

    {
      enabled: true,
      keepPreviousData: true,
    }
  );

  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams({
      ...queryParams,
      ...debouncedFilterParams,
      customerId: customerId,
    });
  }, [debouncedFilterParams, customerId]);

  console.log(data);

  return (
    <CustomerProfileWrapper isStore={true} customerId={customerId}>
      <section className={`custom-stats mb-3  custom-two-third-column`}>
        <div className="custom-stat-chart border rounded-4 ">
          <InvoiceAnalysisChart isStore={true} customerId={customerId} />

          {/* <RevenueVsExpenses /> */}
        </div>
        <div className="custom-stat-chart  border rounded-4">
          <InvoiceAnalysisPieChart isStore={true} customerId={customerId} />
        </div>

        <div className="custom-stat-chart border rounded-4 ">
          <Card className="    border-0">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-start mb-3">
                <h6>
                  Customer Performance
                  <button
                    title="Refresh"
                    onClick={() => refetch()}
                    className="btn text-primary"
                  >
                    <CachedIcon />
                  </button>
                </h6>
              </div>
              <div className=" mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <p>Progress</p>
                  <h6>{data?.targetDashboard?.progress}%</h6>
                </div>
                <ProgressBar now={data?.targetDashboard?.progress} />
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <span className="chart-text ">Current</span>
                  <Link
                    to={`/reports/customer-target?customerId=${customerId}`}
                  >
                    <h6>
                      {" "}
                      {currency(Number(data?.targetDashboard?.total)).format({
                        separator: ",",
                        symbol: prevailingCurrencySymbol,
                      })}
                    </h6>
                  </Link>
                </div>
                <div className="col-md-6 mb-3">
                  <span className="chart-text ">Target</span>
                  <Link
                    to={`/reports/customer-target?customerId=${customerId}`}
                  >
                    <h6>
                      {currency(
                        Number(data?.targetDashboard?.targetAmount)
                      ).format({
                        separator: ",",
                        symbol: prevailingCurrencySymbol,
                      })}
                    </h6>
                  </Link>
                </div>
                <div className="col-md-6 mb-3">
                  <span className="chart-text ">Remaining</span>
                  <Link
                    to={`/reports/customer-target?customerId=${customerId}`}
                  >
                    <h6>
                      {" "}
                      {currency(
                        Number(data?.targetDashboard?.remainingAmount)
                      ).format({
                        separator: ",",
                        symbol: prevailingCurrencySymbol,
                      })}
                    </h6>
                  </Link>
                </div>
              </div>
            </Card.Body>
          </Card>
          {/* <RevenueVsExpenses /> */}
        </div>
      </section>
      {/* <main className="cash-book ">
        <div className="content border rounded-4">
          <div className="content-main">
            <div className="content-body">
            
            </div>
          </div>
        </div>
        <ModalLoader show={isfetching} />
      </main> */}
    </CustomerProfileWrapper>
  );
}

export const CustomInvoiceButton = () => {
  const navigate = useNavigate();

  return (
    <Dropdown>
      <Dropdown.Toggle variant="" bsPrefix="change" className=" border-0">
        <Button className="d-flex text-nowrap align-items-center  me-n2 bg-primary-invoice-btn">
          Create Invoice <ChevronDownIcon />
        </Button>
      </Dropdown.Toggle>
      <Dropdown.Menu
        popperConfig={{
          strategy: "fixed",
        }}
        renderOnMount
        className=" border rounded-4"
      >
        <Dropdown.Item
          as={"button"}
          onClick={() => navigate("/invoices/create-standard-invoice")}
          variant=""
          className=" d-flex gap-1 align-items-center"
        >
          <StandardInvoiceIcon />
          One Time Invoice
        </Dropdown.Item>

        {/* {authUser?.planType?.toLowerCase() !== "free" && (
        )} */}
        <Dropdown.Item
          as={"button"}
          onClick={() => navigate("/invoices/create-reoccurring-invoice")}
          variant=""
          className=" d-flex gap-1 align-items-center"
        >
          <ReoccurringInvoiceIcon />
          Reoccurring Invoice
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
